export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file); // 读取为 base64
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
export function isFormatFile(file, types) {
  const allowedExtensions = types;
  const fileName = file.name.toLowerCase();

  return allowedExtensions.some((ext) => fileName.endsWith(ext));
}

// 文件后缀
export function fileExtension(name) {
  const fileName = name.toLowerCase();
  const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

  return extension;
}

export function canvasToBase64(canvasId) {}
